module.exports = __webpack_public_path__ + "static/media/video.thumbnail.1.aeb77e90.jpg";